module.exports = __webpack_public_path__ + "img/top-list-left3.b6f16c34.png";